import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Grid } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTextInput } from 'components/common/form/text';
import { SelectHitterDataSource } from 'components/common/hitters/select-hitter-data-source';
import { SelectHitterLevel } from 'components/common/hitters/select-hitter-level';
import { SelectHitterRosterStatus } from 'components/common/hitters/select-hitter-roster-status';
import { SelectHitterSide } from 'components/common/hitters/select-hitter-side';
import { HittersContext } from 'contexts/hitters.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';

export const HitterLibraryFilters = () => {
  const { filters, setFilters } = useContext(HittersContext);

  return (
    <ErrorBoundary identifier="HitterLibraryFilters">
      <Grid flexGrow="1" columns="5" gap={RADIX.FLEX.GAP.SM}>
        <CommonTextInput
          id="filter-hitter-name"
          placeholder="common.search-by-name"
          leftSlot={<MagnifyingGlassIcon />}
          value={filters.name}
          debounceMs={300}
          onChange={(v) =>
            setFilters({
              ...filters,
              name: v,
            })
          }
        />
        <SelectHitterSide />
        <SelectHitterLevel />
        <SelectHitterDataSource />
        <SelectHitterRosterStatus />
      </Grid>
    </ErrorBoundary>
  );
};
